import { gql } from '@apollo/client';

export const WISH_LISTS_BY_USER_ID = gql`
  query WishListsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelWishListFilterInput
    $limit: Int
    $nextToken: String
) {
  wishListsByUserID(
    userID: $userID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      userID
      wishListStudios {
        items {
          id
          wishListID
          studioID
          studio {
            id
            images
          }
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`

export const WISH_LIST_STUDIOS_BY_WISH_LIST_ID = gql`
  query WishListStudiosByWishListID(
    $wishListID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelWishListStudioFilterInput
    $limit: Int
    $nextToken: String
) {
  wishListStudiosByWishListID(
    wishListID: $wishListID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      wishListID
      studioID
      wishList {
        id
        name
        userID
        createdAt
        updatedAt
        __typename
      }
      studio {
        id
        StudioName
        images
        studioLocation
        pricePerHour
        pricingMode
        tieredPricing {
          minPersons
          maxPersons
          pricePerHour
        }
        packages {
          id
          name
          durationHours
          prices {
            minPersons
            maxPersons
            price
          }
        }
        userID
        studioTypes
        tagValues
        studioSize
        numberOfPeople
        city
        postcode
        country
        minNumberOfHours
        amenities
        averageRating
        reviewCount
        status
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`

export const GET_WISH_LIST = gql`
  query GetWishList($id: ID!) {
    getWishList(id: $id) {
      id
      name
      userID
      wishListStudios {
        items {
          id
          studioID
          studio {
            id
            StudioName
            images
            pricePerHour
            pricingMode
            tieredPricing {
              minPersons
              maxPersons
              pricePerHour
            }
            packages {
              id
              name
              durationHours
              prices {
                minPersons
                maxPersons
                price
              }
            }
            city
            country
            status
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`